import { Link, useSearch } from "@tanstack/react-router";
import { AnalyticsEvents, useAnalytics } from "@/utils/analytics";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export function FeedOrderSelector() {
	const { track } = useAnalytics();
	const { order } = useSearch({
		from: "/_visibility/_topnav/_tabs/_sidebar/comunidade",
	});

	return (
		<Card className="px-6 h-[86px] flex flex-row gap-3 items-center justify-between w-full overflow-x-auto no-scrollbar">
			<div className="flex flex-row gap-3">
				<Link
					from="/comunidade/"
					search={(s) => ({ ...s, order: "newest" })}
					onClick={() =>
						track(AnalyticsEvents.NAV_FEED_ORDER_CHANGED, { order: "newest" })
					}
				>
					<Button variant={order === "newest" ? "default" : "ghost"}>
						Mais Recentes
					</Button>
				</Link>
				<Link
					from="/comunidade/"
					search={(s) => ({ ...s, order: "oldest" })}
					onClick={() =>
						track(AnalyticsEvents.NAV_FEED_ORDER_CHANGED, { order: "oldest" })
					}
				>
					<Button variant={order === "oldest" ? "default" : "ghost"}>
						Mais Antigos
					</Button>
				</Link>
				<Link
					from="/comunidade/"
					search={(s) => ({ ...s, order: "trending" })}
					onClick={() =>
						track(AnalyticsEvents.NAV_FEED_ORDER_CHANGED, { order: "trending" })
					}
				>
					<Button variant={order === "trending" ? "default" : "ghost"}>
						Mais Relevantes
					</Button>
				</Link>
			</div>
		</Card>
	);
}
